import { ReactNode } from 'react';

import { ColumnDef, VisibilityState } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { DataTable } from '@/components/ui/table/data-table';
import type { EvaluationWithSimulation } from '@/modules/simulations/types';

interface EvaluationsTableProps {
  evaluations: EvaluationWithSimulation[];
  columns: ColumnDef<EvaluationWithSimulation>[];
  isLoading: boolean;
  getRowHref: (evaluation: EvaluationWithSimulation) => string;
  columnVisibility?: VisibilityState;
  onColumnVisibilityChange?: (visibility: VisibilityState) => void;
  paginationCenterContent?: ReactNode;
}

export const EvaluationsTable = ({
  evaluations,
  columns,
  isLoading,
  getRowHref,
  columnVisibility,
  onColumnVisibilityChange,
  paginationCenterContent,
}: EvaluationsTableProps) => {
  const { t } = useTranslation();

  return (
    <DataTable.Root
      fill
      className="min-h-0 flex-1"
      columns={columns}
      data={evaluations}
      rowCount={evaluations.length}
      resourceName="evaluation"
      isLoading={isLoading}
      emptyStateMessage={t('simulations.no_evaluations_found')}
      getRowHref={getRowHref}
      autoResetPageIndex
      columnVisibility={columnVisibility}
      onColumnVisibilityChange={onColumnVisibilityChange}
    >
      <DataTable.Content />
      <DataTable.Pagination centerContent={paginationCenterContent} />
    </DataTable.Root>
  );
};
